import { render, staticRenderFns } from "./ModalComprovanteAcessorio.vue?vue&type=template&id=2b5bfac8&scoped=true"
import script from "./ModalComprovanteAcessorio.vue?vue&type=script&lang=js"
export * from "./ModalComprovanteAcessorio.vue?vue&type=script&lang=js"
import style0 from "./ModalComprovanteAcessorio.vue?vue&type=style&index=0&id=2b5bfac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bfac8",
  null
  
)

export default component.exports